import { SvgIcon, type SvgIconProps } from "@mui/material";
import type { FC } from "react";

/** The stroke, in the icon's 24-unit viewBox: a hairline next to MUI's filled glyphs, so a row's remove action stays quiet. */
const STROKE_WIDTH = 1.7;

type Props = {
	/** MUI's icon size, or `inherit` to take the size from the parent's `font-size`. */
	fontSize?: SvgIconProps["fontSize"];
	sx?: SvgIconProps["sx"];
	dataTestId?: string;
};

/**
 * A light-stroke trash can (lid, handle, body and two ribs) for a remove action repeated down a dense list — a grid
 * row's or a group band's trash — where MUI's filled `DeleteOutline` outweighs the figures beside it. Paints in
 * `currentColor`, like any MUI icon, so the caller's button owns its rest and hover colours. Decorative: the button
 * that holds it carries the accessible name.
 */
export const TrashLineIcon: FC<Props> = ({ fontSize, sx, dataTestId }) => (
	<SvgIcon fontSize={fontSize} sx={sx} data-testid={dataTestId} aria-hidden>
		<path
			d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12M9 7V4.5A1.5 1.5 0 0110.5 3h3A1.5 1.5 0 0115 4.5V7"
			fill="none"
			stroke="currentColor"
			strokeWidth={STROKE_WIDTH}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</SvgIcon>
);
